import React from "react";
import { GaugeChart } from "@carbon/charts-react";
import PropTypes from "prop-types";
import Typography from "../Basics/Typography";
import { g100 } from "@carbon/themes";
import { toolbarOptions } from "./utils";
import { Div } from "../Basics/Div.styles";

const Gauge = ({
  height = "15rem",
  isBold = false,
  footer = "",
  title = "Gauge Graph",
  percentage = 0,
  change = "",
  noMetric = false,
  maxPercent = 100,
  arrowStatus
}) => {
  const state = {
    data: [
      {
        group: "value",
        value: Math.round((percentage / maxPercent) * 100),
      },
      {
        group: "delta",
        value: Number(change) || 0,
      },
    ],
    options: {
      title: `${title}`,
      resizable: true,
      height: `${height}`,
      width: "100%",
      gauge: {
        type: "semi",
        status: arrowStatus,
        numberFormatter: (value) => {
          const numericValue = Number(value); // Convert string to number

          if (isNaN(numericValue)) {
            // If conversion fails, return the original string (fallback)
            return noMetric ? `${value} m3` : value;
          }

          // Ensure correct display based on `noMetric`
          return noMetric ? `${percentage} m3` : numericValue;
        },
        valueFontSize: (value) => (isBold ? 54 : value / 4),
        deltaFontSize: () => (isBold ? 24 : 12),
        showPercentageSymbol: false,
        alignment: "center",
        deltaArrow: {
          enabled: !isBold,
        },
      },
      theme: "g100",
      ...toolbarOptions,
    },
  };

  return (
    <Div
      className={isBold && "bold"}
      display="flex"
      $flexDirection="column"
      $alignItems="center"
    >
      <GaugeChart data={state.data} options={state.options} />
      {footer && (
        <Typography
          className="cds--type-helper-text-01"
          color={g100.textSecondary}
          margin="20px 0 20px 0 !important"
        >
          {footer}
        </Typography>
      )}
    </Div>
  );
};

export default Gauge;
